import React from "react";
import { Suspense } from "react";
import { Route, Routes} from "react-router-dom";
import Login from "../components/pages/login/Login";
import Dashboard from "../components/pages/dashboard/Dashboard";
import AllJobs from "../components/pages/allJobs/AllJobs";
import Earning from "../components/pages/earning/Earning";
import Setting from "../components/pages/setting/Setting";
import JobDetail from "../components/pages/jobDetail/JobDetails";
import Applicant from "../components/pages/applicant/Applicant";
import UploadCandidate from "../components/pages/uploadCandidate/UploadCandidate";
import History from "../components/pages/history/History";
import InternalError from "../components/pages/error/InternalError";
import Error from "../components/pages/error/Error";
import CreatePassword from "../components/form/login/CreatePassword";
import ResetPassword from "../components/form/login/ResetPassword";
import Layout from "../components/layout/Layout";


function ComponentWithLayout({type}){

   const getComponent = () => {
    switch(type){
      case "DASHBOARD":
        return <Dashboard />
      case "ALL_JOBS":
        return <AllJobs />
      case "JOBDETAILS":
        return <JobDetail />
      case "APPLICANT":
        return <Applicant />
      case "EARNING":
        return <Earning />
      case "HISTORY":
        return <History />
      case "SETTINGS":
        return <Setting />
      case "UPLOADCANDIDATE":
        return <UploadCandidate />
      
    }
  }
  return (
    // React.createElement(
    //   layout,
    //   null,
    //   component
    // )

    <Layout>
      {getComponent()}
    </Layout>
  )
}

function allRoutes() {

  return (
    <>
 
      <Suspense>
        <Routes>
          <Route exact path="/" Component={Login} />
          {/* <Route exact path="reset-password" Component={ResetPassword} /> */}
          <Route  path="reset-password/:uid/:token/:firstName/:lastName" Component={ResetPassword} />
          {/* <Route exact path=":id" component={ResetPassword}/> 
          </Route> */}
          {/* <Route exact path="/dashboard" Component={Dashboard} /> */}
          {/* <Route exact path="/all-jobs" Component={AllJobs} />
          <Route exact path="/job-details/:id" Component={JobDetail} /> */}
          {/* <Route exact path="/job-details/:id:compa" Component={JobDetail} /> */}
          {/* <Route exact path="/applicant/:id" Component={Applicant} />
          <Route exact path="/my-earning" Component={Earning} />
          <Route exact path="/history" Component={History} />
          <Route exact path="/settings" Component={Setting} />
          <Route exact path="/upload-candidate" Component={UploadCandidate} />
          <Route exact path="/upload-candidate/:id" Component={UploadCandidate} />
          <Route exact path="/upload-candidate/:id/:compnayId" Component={UploadCandidate} /> */}
          {/* <Route exact path="*" Component={InternalError} /> */}
          <Route exact path="/error" Component={Error} />
          <Route exact path="/dashboard" element={
            <ComponentWithLayout type="DASHBOARD" component={Dashboard} layout={Layout}/>
          } />
          
          <Route exact path="/all-jobs/:id" element={
            <ComponentWithLayout type="ALL_JOBS" component={AllJobs} layout={Layout}/>
          } />
      
          <Route exact path="/job-details/:id" element={
            <ComponentWithLayout type="JOBDETAILS" component={JobDetail} layout={Layout}/>
          } />
          <Route exact path="/applicant/:id" element={
            <ComponentWithLayout type="APPLICANT" component={Applicant} layout={Layout}/>
          } />
          <Route exact path="/my-earning" element={
            <ComponentWithLayout type="EARNING" component={Earning} layout={Layout}/>
          } />
          <Route exact path="/history" element={
            <ComponentWithLayout type="HISTORY" component={History} layout={Layout}/>
          } />
          <Route exact path="/settings" element={
            <ComponentWithLayout type="SETTINGS" component={Setting} layout={Layout}/>
          } />
          <Route exact path="/upload-candidate" element={
            <ComponentWithLayout type="UPLOADCANDIDATE" component={UploadCandidate} layout={Layout}/>
          } />
          {/* <Route exact path="/upload-candidate/:id/:compnayId" element={
            <ComponentWithLayout type="UPLOADCANDIDATE" component={UploadCandidate} layout={Layout}/>
          } />
          <Route exact path="/upload-candidate/:id" element={
            <ComponentWithLayout type="UPLOADCANDIDATE" component={UploadCandidate} layout={Layout}/>
          } /> */}
        </Routes>
        
      </Suspense>
    </>
  );
}

export default allRoutes;
